import {
     HttpInterceptor,
     HttpRequest,
     HttpHandler,
     HttpEvent

} from '@angular/common/http';
import { Observable } from "rxjs";
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './services/auth.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class AuthInterceptor  implements HttpInterceptor{
    constructor(private jwtHelper: JwtHelperService, private authService : AuthService) {
    }
 
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.jwtHelper.tokenGetter();
        const cloneReq = req.clone({headers: req.headers.set('Authorization',token)});
        return next.handle(cloneReq);
    }
}
